export default __webpack_public_path__ + "static/media/list2.9580d4c1.png";